export default __webpack_public_path__ + "static/media/approved.2391b7bf.svg";